import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import './dialog.scss';
import BaseConfirmationDialog from './BaseConfirmationDialog';


const DeleteConfirmationDialog = ({onDismiss, onSubmit, open, contentSlot,
    onOutsideClick, classes, params = {}}) => {
    const {type, buttonText, cancelButtonText, itemName = '', containChildren = false} = params;
    const confirmation = {
        question: `deleteModal.header.${type ? type : 'default'}`,
        message: containChildren ? 'deleteModal.mainText.deleteWithChildren' : `deleteModal.mainText.${type ? type : 'default'}`,
        itemName,
    };
    return (<BaseConfirmationDialog
        onDismiss={onDismiss}
        onSubmit={onSubmit}
        open={open}
        onOutsideClick={onOutsideClick}
        contentSlot={contentSlot}
        cancelButtonText={cancelButtonText ? cancelButtonText : 'cancel'}
        buttonText={buttonText ? buttonText : 'delete'}
        text={confirmation}
        classes={classes}
    />
    );
};

DeleteConfirmationDialog.propTypes = {
    onDismiss: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    open: PropTypes.bool,
    text: PropTypes.object,
    windowIcon: PropTypes.string,
};

export default observer(DeleteConfirmationDialog);
